import React, { useEffect, useState } from 'react';
import { Button, Text, FlexWrapper, FontIcon } from '@intigral/shared';
import { FlexChild } from '@intigral/shared/lib/components/FlexWrapper';
import user from '../helpers/user';
import { showUpdatePayment } from '@intigral/utils/lib/user/ui';
import { useLocation } from 'react-router-dom';
import { __ } from '../translations';
import { getBaseSubscription } from '@intigral/utils/lib/user';
import { useSelector } from 'react-redux';
import { IStore } from '../interfaces/StoreTypes';
import { getPathNameWithoutLangPrefix } from '@intigral/utils';
import { useConsentCheck } from '../hooks/useConsentCheck';
import { useConfigurationSections } from '../hooks/useConfiguration';
import { Modal } from '../components/ui/Modal';
import { isIapOperator } from '../utils/user';

export const PaymentFailurePage: React.FC = () => {
    const userInfo = user.getUserInfo();
    const baseSubscription = getBaseSubscription(userInfo);
    const [isOpen, setIsOpen] = useState(false);
    const location = useLocation();
    const profile = useSelector((store: IStore) => store.profile);
    const { data: consentData } = useConsentCheck(profile?.selectedProfile);
    // Using React Query instead of Redux for configuration
    const { consentManagement, iap_operators } = useConfigurationSections();
    const { enabledV2 } = consentManagement || {};
    const isIapUser = isIapOperator(userInfo?.operator, iap_operators);

    useEffect(() => {
        const pathWithoutLang = getPathNameWithoutLangPrefix(location?.pathname);
        if (!profile?.selectedProfile?.profileGuid || pathWithoutLang != '') {
            setIsOpen(false);
        } else {
            if (enabledV2) {
                if (consentData && !consentData?.consentNeeded) {
                    setIsOpen(showUpdatePayment(userInfo));
                }
            } else {
                setIsOpen(showUpdatePayment(userInfo));
            }
        }
    }, [
        userInfo?.statusName,
        baseSubscription?.statusName,
        profile?.selectedProfile?.profileGuid,
        consentData?.consentNeeded,
        enabledV2,
    ]);
    const getPaymentFailureDescription = () => {
        if (isIapUser) {
            return __('payment_failure_popup_desc_iap');
        }
        return __('payment_failure_popup_desc_default');
    };
    const handleClosePopup = () => {
        setIsOpen(false);
    };

    const navigateToAccountPage = () => {
        if (user?.getMyAccountUrl()) {
            window.location.replace(user.getMyAccountUrl());
        }
    };

    const handleUpdatePayment = () => {
        navigateToAccountPage();
    };

    const handleDowngradeToBasic = () => {
        navigateToAccountPage();
    };

    return (
        <Modal
            useFlexLayout={false}
            open={isOpen}
            onOpenChange={handleClosePopup}
            closePlacement="end"
            widthSet="medium"
        >
            <FlexWrapper flexDirection="column" gap={{ default: '2x', md: '3x' }}>
                <FontIcon name="info" size="size60" md="size60" />
                <Text as="h3" variant="h3" margin="0" size={{ default: '22', md: '28' }}>
                    {__('payment_failure_popup_title')}
                </Text>
                <Text as="p" margin="0" color="gray" alignment="center">
                    {getPaymentFailureDescription()}
                </Text>
                {!isIapUser ? (
                    <FlexWrapper flexDirection="column" gap={{ default: '2x', md: '3x' }} paddingTop={{ default: '2x' }}>
                        <FlexWrapper
                            direction={{ default: 'column', md: 'row' }}
                            itemCount={{ default: 1, md: 2 }}
                            gap={{ default: '2x', md: '4x' }}
                        >
                            <FlexChild order={{ default: 2, md: 1 }}>
                                <Button onClick={handleDowngradeToBasic} fullWidth>
                                    {__('payment_failure_popup_downgrade')}
                                </Button>
                            </FlexChild>
                            <FlexChild order={{ default: 1, md: 2 }}>
                                <Button primary onClick={handleUpdatePayment} fullWidth>
                                    {__('payment_failure_popup_update_payment')}
                                </Button>
                            </FlexChild>
                        </FlexWrapper>
                    </FlexWrapper>
                ) : null}
            </FlexWrapper>
        </Modal>
    );
};
